module.exports = __webpack_public_path__ + "img/nav-vip.b57fe069.png";